import React from "react";
import PropTypes from "prop-types";
import SidebarIconSvg from "./SidebarIconSvg";

const SidebarIconChartBar = ({ className, size }) => (
  <SidebarIconSvg className={className} size={size}>
    <line x1="12" y1="20" x2="12" y2="10" />
    <line x1="18" y1="20" x2="18" y2="4" />
    <line x1="6" y1="20" x2="6" y2="16" />
  </SidebarIconSvg>
);

SidebarIconChartBar.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};

export default SidebarIconChartBar;
